import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
  Textarea,
} from '@planuze/ui';
import { useEffect, useState } from 'react';
import { useCompaniesContent } from '../../content/sections/companies.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly title: string;
  readonly description: string;
  readonly confirmLabel: string;
  readonly destructive?: boolean;
  readonly pending: boolean;
  /** Bound de validação vive em @planuze/admin-contracts (não duplicado aqui). */
  readonly validate: (reason: string) => boolean;
  readonly onConfirm: (reason: string) => void;
}

/* Modal de motivo reutilizável para ações em empresas (block/unblock). `locked`
   enquanto pendente bloqueia ESC/overlay/X (ADR-0216); reseta o motivo ao fechar. */
export function CompanyReasonDialog(props: Props) {
  const {
    open,
    onClose,
    title,
    description,
    confirmLabel,
    destructive,
    pending,
    validate,
    onConfirm,
  } = props;
  const copy = useCompaniesContent();
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (!open) setReason('');
  }, [open]);

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next && !pending) onClose();
      }}
    >
      <DialogContent locked={pending}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label htmlFor="company-reason">{copy.reasonDialog.reasonLabel}</Label>
          <Textarea
            id="company-reason"
            rows={3}
            maxLength={500}
            value={reason}
            placeholder={copy.reasonDialog.reasonPlaceholder}
            onChange={(e) => setReason(e.target.value)}
          />
          <p className="text-xs text-muted-foreground">
            {copy.reasonDialog.characterCount(reason.length)}
          </p>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} disabled={pending}>
            {copy.reasonDialog.cancel}
          </Button>
          <Button
            variant={destructive === true ? 'destructive' : 'default'}
            loading={pending}
            disabled={!validate(reason)}
            onClick={() => onConfirm(reason)}
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
